import React from "react";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import InputName from "../../common/Input/InputName";
import InputNumber from "../../common/Input/InputPhNumber";
import InputEmail from "../../common/Input/InputEmail";
import InputPINCode from "../../common/Input/InputPinCode";
import InputAdhar from "../../common/Input/InputAdhar";
import InputImage from "../../common/Input/InputImage";
import InputDobOrAge from "../../common/Input/InputDobOrAge";
export const UserEditProfile = ({
  setModalShow,
  modalshow,
  userData,
  handleSelectChange,
  Country,
  state,
  cities,
  handleInputChange,
  handleUpdate,
  genderOptions,
  handleImageUpload,
  isDobDisabled,
  isAgeDisabled,
  setInputError,
}) => {
  return (
    <>
      <Modal
        centered
        show={modalshow}
        onHide={() => setModalShow(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6">
                <InputName
                  name="name"
                  placeholder="Enter Name"
                  fieldName="Name"
                  value={userData?.name}
                  onChange={handleInputChange}
                  label="Name"
                  setInputNameError={setInputError}
                />
              </div>
              <div className="col-md-6">
                <InputImage
                  name="profile_image"
                  onChange={handleImageUpload}
                  label="Profile Image"
                  value={userData?.profilePic}
                  setInputImgError={setInputError}
                  multiple={false}
                  required={false}
                  minSize={10 * 1024}
                  maxSize={1 * 1024 * 1024}
                />
              </div>
              <div className="col-md-6">
                <InputNumber
                  name="phone"
                  value={userData?.phone}
                  onChange={handleInputChange}
                  placeholder="Enter Phone Number"
                  fieldName="Phone"
                  label="Phone"
                  setInputNumberError={setInputError}
                />
              </div>
              <div className="col-md-6">
                <InputNumber
                  name="alternate_Phone"
                  value={userData?.alternate_Phone}
                  onChange={handleInputChange}
                  placeholder="Enter Alternate Phone Number"
                  label="Alernate Phone"
                  fieldName="Alternate Phone"
                  setInputNumberError={setInputError}
                />
              </div>
              <div className="col-md-6">
                <InputEmail
                  name="email"
                  value={userData?.email}
                  onChange={handleInputChange}
                  placeholder="Enter Email"
                  fieldName="Email"
                  label="Email"
                  setInputEmailError={setInputError}
                />
              </div>
              <div className="col-md-6">
                <InputAdhar
                  name="aadhar_number"
                  value={userData?.aadhar_number}
                  onChange={handleInputChange}
                  placeholder="Enter Aadhar Number"
                  fieldName="Aadhar"
                  label="AADHAR"
                  required={true}
                  setInputAdharError={setInputError}
                />
              </div>
              <InputDobOrAge
                dob={userData?.dob}
                age={userData?.age}
                onChange={handleInputChange}
                dobSize="col-xl-6"
                ageSize="col-xl-6"
              />
              <div className="col-md-6">
                <div className="form-group">
                  <label>Gender</label>
                  <Select
                    name="gender"
                    value={
                      userData?.gender
                        ? { value: userData.gender, label: userData.gender }
                        : null
                    }
                    placeholder="Select Gender"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "gender")
                    }
                    options={genderOptions}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Country</label>
                  <Select
                    name="country"
                    value={
                      userData?.address?.country
                        ? {
                            value: userData?.address.country,
                            label: userData?.address.countryName,
                          }
                        : null
                    }
                    placeholder="Select country"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "country")
                    }
                    options={Country.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>State</label>
                  <Select
                    name="state"
                    value={
                      userData?.address.state
                        ? {
                            value: userData?.address.state,
                            label: userData?.address.stateName,
                          }
                        : null
                    }
                    placeholder="Select state"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "state")
                    }
                    options={state?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>City</label>
                  <Select
                    name="city"
                    value={
                      userData?.address.city
                        ? {
                            value: userData?.address.city,
                            label: userData?.address.cityName,
                          }
                        : null
                    }
                    placeholder="Select city"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "city")
                    }
                    options={cities?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Area</label>
                  <input
                    name="area"
                    value={userData?.address.area}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>LandMark</label>
                  <input
                    name="landMark"
                    value={userData?.address.landMark}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Street</label>
                  <input
                    name="street"
                    value={userData?.address.street}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Plot/House</label>
                  <input
                    name="plot"
                    value={userData?.address.plot}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <InputPINCode
                  name="pin"
                  value={userData?.address.pin}
                  onChange={handleInputChange}
                  label="Pincode"
                  setInputPINCodeError={setInputError}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setModalShow(false)}
            className="p-2"
          >
            Cancel
          </Button>
          <Button variant="danger" className="p-2" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
